import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './image.css';

const Image = ({ src, srcSet, alt, title, contained, stretched, loading, onLoad, fallbackSrc }) => {
    const imageClassnames = cx(styles.image, {
        [styles.contained]: contained,
        [styles.stretched]: stretched,
    });
    const image = (
        <img
            className={imageClassnames}
            src={src}
            alt={alt}
            title={title}
            loading={loading}
            onLoad={onLoad}
            onError={(e) => {
                if (fallbackSrc && e.target.src !== fallbackSrc) {
                    e.target.onerror = null;
                    e.target.src = fallbackSrc;
                }
            }}
        />
    );

    if (srcSet) {
        return (
            <picture>
                {srcSet.map(({ media, src: srcSetSrc }) => (
                    <source key={media} srcSet={srcSetSrc} media={media} />
                ))}

                {image}
            </picture>
        );
    }

    return image;
};

Image.propTypes = {
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.arrayOf(
        PropTypes.shape({
            media: PropTypes.string.isRequired,
            src: PropTypes.string.isRequired,
        }),
    ),
    alt: PropTypes.string,
    title: PropTypes.string,
    contained: PropTypes.bool,
    stretched: PropTypes.bool,
    loading: PropTypes.oneOf(['lazy', 'eager', 'auto']),
    onLoad: PropTypes.func,
    fallbackSrc: PropTypes.string,
};

Image.defaultProps = {
    loading: 'auto',
    srcSet: null,
    alt: undefined,
    title: undefined,
    contained: false,
    stretched: false,
    onLoad: undefined,
    fallbackSrc: undefined,
};

export default Image;
